<template>
    <b-col class="trainer-reviews reviews-section mb-4" :class="{'is-shown': offer.showTrainerReviews}" md="4" v-if="trainerRating && trainerRating.length != 0 && (editable || offer.showTrainerReviews)">
        <div>
            <div class="hide-overlay"></div>
            <b-button 
                class="btn-toggle"
                :variant="offer.showTrainerReviews ? 'outline-danger' : 'outline-success'"
                size="sm"
                @click="toggle"
            >
                <span v-if="offer.showTrainerReviews"><i class="material-icons">visibility_off</i> {{name}} ausblenden</span>
                <span v-else><i class="material-icons">visibility</i> {{name}} einblenden</span>
            </b-button>
        </div>
        
        <b-card>
            <h3 :class="{'mb-2 heading-hidden': !offer.showTrainerReviews}">{{ $t('reviews.trainerHeading', { trainer: `${trainerTitle} ${trainerName}`.trim() }) }}</h3>
            <b-collapse :visible="offer.showTrainerReviews === 1 ? true : false" :id="`collapse-${selfId}`">
                <div class="trainer-scrollable">
                    <div 
                        v-for="(review, index) in trainerRating"
                        :key="index"
                    >
                        <Review 
                            :review="getTrainerReview(review)"
                        />
                        <small>
                            <Author 
                                show-author 
                                show-city 
                                show-company 
                                show-date
                                :author="getAuthor(review)"
                            />
                        </small>
                        <hr>
                    </div>
                </div>
            </b-collapse>
        </b-card>
    </b-col>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Review from './Review'
import Author from './Author.vue';


export default {
    name: 'TrainerReviews',
    props: {
        editable: Boolean
    },
    data() {
        return {
            name: 'Trainer-Bewertungen'
        }
    },
    components: {
        Review,
        Author
    },
    computed: {
        ...mapGetters([
            'trainerRating',
            'trainer',
            'offer',
        ]),
        selfId () {
            return this.$attrs.id;
        },
        trainerName: function () {
            return this.trainer && this.trainer.contact
                ? this.trainer.contact.firstName + ' ' + this.trainer.contact.lastName
                : this.placeholder;
        },
        trainerTitle: function () {
            let title = this.trainer && this.trainer.contact
                ? this.trainer.contact.gender === 'm'
                ? this.$t('trainerProfile.maleTitle')
                : ['f', 'w'].includes(this.trainer.contact.gender)
                  ? this.$t('trainerProfile.femaleTitle')
                  : ''
                : this.placeholder;
            if(this.trainer && this.trainer.contact && this.trainer.contact.title) {
                title += ' ' + this.trainer.contact.title;
            }
            return title;
        }
    },
    methods: {
        ...mapMutations(['offerSet']),
        getTrainerReview(review) {
            let result = {}
            result['trainerReview'] = review['trainerReview'];
            return result;
        },
        getAuthor: function (review) {
            let author = {...review.author};
            return Object.assign(author, {date: review.createdAt});
        },
        toggle() {
            this.offerSet({showTrainerReviews: this.offer.showTrainerReviews ? 0 : 1 })
            this.$emit('dirty');
        }
    },
}
</script>

<style scoped>
.reviews-section .hide-overlay {
  position:absolute; 
  margin: -1em; 
  top:0; 
  bottom: -3.5em; 
  left: 0; 
  right: 0; 
  border-radius: .25em;
  background-color: transparent;
  transition: background-color .5s ease;
}

.reviews-section .btn-toggle {
  display: none;
}
.reviews-section:hover .hide-overlay {
  z-index: 0;
  /*border: 1px solid #777;*/
  outline: 2px solid rgba(40, 167, 69, .2);
  
}
.reviews-section.is-shown:hover .hide-overlay {
  outline: 2px solid rgba(220, 53, 69, .2);

}
.reviews-section:hover  .btn-toggle {
  z-index: 1; 
  text-align: center;
  position: absolute;
  right: 15px;
  bottom: -3em;
  display: inline-block;
}
.reviews-section:hover .hide-overlay .btn-toggle .material-icons {
  vertical-align: text-top;
  font-size: 1.1em;
  
}
.reviews-section .btn-outline-light:hover,
.reviews-section .btn-outline-light:active,
.reviews-section .btn-outline-light:focus {
  border-color: black;
  color: #000;;
}

.heading-hidden {
  color: #aaa;
  text-decoration: line-through;
}
.reviews-section:hover .heading-hidden {
  color: #777;
  text-decoration: initial
}
.reviews-section.is-shown:hover h3 {
  color: #333;
}
</style>
